<script lang="ts" setup>
defineProps({
  history: {
    type: Array as () => Array<any>,
    default: () => [],
  },
});
const emit = defineEmits(['deleteHistory', 'closeHistory', 'goHistorySearch']);
const route = useRoute();

const deleteHistory = (index?: number) => {
  emit('deleteHistory', index);
};

const closeHistory = (item: string) => {
  if (route.query?.query === item) emit('closeHistory', item);
};

const goHistorySearch = (to: string) => {
  emit('goHistorySearch', decodeURI(to));
};
const color = ref([]);
</script>

<template>
  <div class="history-wrapper">
    <div class="history-header">
      <div class="text">История</div>
      <div class="clear" @click="deleteHistory()">Очистить</div>
    </div>
    <ul v-if="history.length" class="items">
      <li
        v-for="(item, i) in history"
        :key="item"
        @click.stop="closeHistory(item)"
      >
        <div
          class="search-history-item"
          @click="goHistorySearch(`/search/?query=${item}`)"
        >
          {{ item }}
        </div>
        <div
          class="del"
          @click.stop="deleteHistory(i)"
          @mouseover="color[i] = '#3616d0'"
          @mouseleave="color[i] = '#86888f'"
        >
          <UiIcon name="close" size="20" :stroke="color[i] || '#86888f'" />
        </div>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
.history-wrapper {
  .history-header {
    display: grid;
    grid-template-columns: auto max-content;
    grid-gap: 6px;
    padding: 20px 0 4px;
    border-bottom: 0;
    font-size: 14px;
    line-height: 20px;

    @include md-block {
      padding: 28px 0 8px;
    }
    @include xl-block {
      padding: 20px 20px 12px;
      border-bottom: 1px solid $achromatic-hover;
      font-size: 16px;
      line-height: 24px;
    }

    .text {
      font-weight: 600;
      color: $achromatic-black;
    }
  }

  .items {
    display: grid;

    li {
      display: grid;
      grid-template-columns: auto max-content;
      align-items: center;
      border-bottom: 1px solid $achromatic-hover;
      font-size: 14px;
      line-height: 20px;

      @include xl-block {
        font-size: 16px;
        line-height: 24px;
      }

      &:last-child {
        border: 0;
      }

      .search-history-item {
        display: block;
        color: $achromatic-black;
        text-decoration: none;
        height: 100%;
        transition: background 0.2s ease;
        padding: 8px 0;
        cursor: pointer;

        @include md-block {
          padding: 12px 0;
        }
        @include xl-block {
          padding: 12px 0 12px 20px;
        }

        &:hover {
          //background: $achromatic-card-bg;

          & + .del {
            //background: $achromatic-card-bg;
          }
        }
      }
    }
  }
  $size: 16px;

  .del {
    cursor: pointer;
    height: 100%;
    width: $size * 2 + 2px;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    svg {
      margin-right: -1px;
    }

    @include xl-block {
      padding: 0 17px;
      width: $size * 4;
    }
  }

  .clear {
    cursor: pointer;
    transition: color 0.2s ease;

    &:hover {
      color: $hover-cta;
    }
  }
}
</style>
